import page404 from './page404.vue'
import pageInfo from './pageInfo.vue'

export default [
  // {
  //   path: '*',
  //   name: '404',
  //   hidden: true,
  //   component: page404
  // },
  // {
  //   path: '/:pathMatch(.*)*',
  //   redirect: '/404',
  //   hidden: true
  // },
  {
    path: '/info',
    name: 'info',
    hidden: true,
    component: pageInfo
  },
  {
    path: '/404',
    name: '404',
    component: page404
  },
  // 刷新页面 必须保留
  {
    path: '/refresh',
    name: 'refresh',
    hidden: true,
    component: {
      beforeRouteEnter (to, from, next) {
        next(vm => vm.$router.replace(from.fullPath))
      },
      render: h => h()
    }
  },
  // 页面重定向 必须保留
  {
    path: '/redirect/:route*',
    name: 'redirect',
    hidden: true,
    component: {
      beforeRouteEnter (to, from, next) {
        next(vm => vm.$router.replace(JSON.parse(from.params.route)))
      },
      render: h => h()
    }
  }]
